import { OfficeSection } from '../../../../officeSection/officeSection';
import { EXPONENT, MULTIPLIER_COEFFICIENT } from '../../getSectionWallsLinear';

export const getOfficeSectionTheoreticalWallsLinear = (officeSection: OfficeSection): number => {
  const surface = officeSection.surface || officeSection.defaultSurface;
  return surface !== 0 ? surface * MULTIPLIER_COEFFICIENT * Math.pow(surface, EXPONENT) : 0;
};
